// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Sl2h","empty":"ModalGraph_empty__av-iY"};